"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DefaultError = function (props) { return (react_1.default.createElement("div", { className: "form-errors" },
    props.formErrors.map(function (error, index) { return (react_1.default.createElement("div", { className: "invalid", key: "formError-" + index }, error)); }),
    props.fieldErrors.map(function (error, index) { return (react_1.default.createElement("div", { className: "invalid", key: "fieldError-" + index }, error.state.errors.map(function (message) { return react_1.default.createElement("div", { key: message }, message); }))); }))); };
exports.DefaultError = DefaultError;
